var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { makeStyles } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
var useStyles = makeStyles(function (theme) { return ({
    actionItem: {
        color: theme.palette.primary.main,
    }
}); });
var Actions = function (_a) {
    var item = _a.item, actions = _a.actions, actionClicked = _a.actionClicked;
    var classes = useStyles();
    var actionItemClicked = function (e, id) {
        actionClicked(e, id);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ActionWrapper, null, actions &&
            actions.length > 0 &&
            actions.map(function (action) {
                var actionId = action.actionId, actionName = action.actionName, Icon = action.actionIcon;
                return (React.createElement(ActionItem, { onClick: function (e) { return actionItemClicked(e, actionId); }, key: actionId, className: classes.actionItem },
                    React.createElement(Icon, { size: "12" }),
                    React.createElement("span", null, actionName)));
            }))));
};
export default Actions;
var ActionWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n"], ["\n    display: flex;\n"])));
var ActionItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n    font-weight: normal;\n    font-size: 10px;\n\n    & span {\n        margin-left: 6px;\n    }\n    svg {\n        width: 12px;\n        height: 12px;\n        vertical-align: middle;\n    }\n"], ["\n    flex: 1;\n    font-weight: normal;\n    font-size: 10px;\n\n    & span {\n        margin-left: 6px;\n    }\n    svg {\n        width: 12px;\n        height: 12px;\n        vertical-align: middle;\n    }\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map